import React from 'react';
import { Countdown } from './Countdown';
export function Urgency() {
  return <section className="w-full bg-navy-deep" data-id="element-301" data-mp="2bwe6imbbrd3g">
      <div className="max-w-3xl mx-auto px-5 py-14 sm:py-16 text-center" data-id="element-302" data-mp="2bvcrk6r6u6gg">
        <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-303" data-mp="1x06lxkw089nn">
          Launch offer
        </p>
        <h2 className="mt-3 font-display font-bold uppercase text-white text-2xl sm:text-4xl" data-id="element-304" data-mp="21x6tk08i5kgv">
          The launch price ends in:
        </h2>
        <div className="mt-6" data-id="element-305" data-mp="1o58uki8i94yf">
          <Countdown tone="dark" data-id="element-306" data-mp="1sy1wkycl9z6t" />
        </div>
        <p className="mt-5 text-sm text-white/70" data-id="element-307" data-mp="1szwiofzljxch">
          After the timer, the launch price ends and the pack goes to{' '}
          <span className="font-bold text-crimson-soft" data-id="element-308" data-mp="1j80agc3sqquj">full price</span>.
        </p>
      </div>
    </section>;
}